module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1vcGFjaXR5PSIwIiBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09Im1hdHJpeCgwIDEgMSAwIDAgMCkiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiNGNUE2MjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTE0IDhMMTAgMTIgMTQgMTYiIHRyYW5zZm9ybT0ibWF0cml4KDAgMSAxIDAgMCAwKSByb3RhdGUoLTkwIDEyIDEyKSIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/arrow_right_orange.svg
// module id = NC9s
// module chunks = 30